import * as FileSaver from 'file-saver';

export function prepararDatosParaExcel(items, columnas) {
    return items.map(item => {
        const fila = {};
        columnas.forEach(col => fila[col.label] = item[col.key]);
        return fila;
    });
}

/**
 * Función asincrónica para exportar datos a un archivo Excel.
 * @param nombreExcel - Nombre del archivo Excel a guardar.
 * @param vectorDatos - Vector de datos a exportar a la hoja de cálculo.
 */
export async function exportarExcel(nombreExcel, vectorDatos) {
    // Importa el módulo 'xlsx' dinámicamente utilizando la función 'import'
    const XLSX = await import('xlsx');

    // Convierte el vector de datos a una hoja de cálculo
    const worksheet = XLSX.utils.json_to_sheet(vectorDatos);

    // Ajusta automáticamente el ancho de las columnas basado en la longitud del texto
    const colWidths = Object.keys(vectorDatos[0]).map((key) => {
        return { wch: key.length + 10 }; // Ajusta según tus necesidades
    });

    // Aplica los anchos de columna a la hoja de cálculo
    worksheet['!cols'] = colWidths;

    // Crea un libro de trabajo con la hoja de cálculo
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };

    // Convierte el libro de trabajo a un búfer de datos de Excel
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });

    // Llama a la función para guardar el archivo Excel
    guardarExcel(excelBuffer, `${nombreExcel}`);
}

/**
 * Función para guardar el archivo Excel en el sistema local.
 * @param buffer - Búfer de datos del archivo Excel.
 * @param nombre - Nombre del archivo Excel.
 */
export function guardarExcel(buffer, nombre) {
    // Obtiene la fecha actual
    const fecha = new Date();

    // Definición de constantes para el tipo y la extensión del archivo Excel
    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const EXCEL_EXTENSION = '.xlsx';

    // Crea un objeto Blob con el búfer de datos y el tipo MIME
    const data = new Blob([buffer], {
        type: EXCEL_TYPE
    });

    // Guarda el archivo Blob en el sistema local utilizando FileSaver.js
    FileSaver.saveAs(data, `${nombre}_${fecha.getUTCDate()}-${fecha.getUTCMonth() + 1}-${fecha.getUTCFullYear()}${EXCEL_EXTENSION}`);
}
